import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InboxCreateTimeeventPage } from './inbox-create-timeevent';

@NgModule({
  declarations: [
    InboxCreateTimeeventPage,
  ],
  imports: [
    IonicPageModule.forChild(InboxCreateTimeeventPage),
  ],
})
export class InboxCreateTimeeventPageModule {}



// WEBPACK FOOTER //
// ./src/pages/inbox-create-timeevent/inbox-create-timeevent.module.ts